import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import CellStyleWrapper from '../../../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'
import CustomDate from '../../../../../../../../../../../../../components/CustomDate'
import Entity from '../../../../../../../../../../../../../components/TableCell/components/Entity'
import Flag from '../../../../../../../../../../../../../components/TableCell/components/Flag'
import InactiveIndicatorCell from '../../../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Cell'
import InactivityIndicatorHeader from '../../../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Header'
import Signals from '../../../../../../../../../../../../../components/TableCell/components/Signals'

import { LOCALE_PREFIX } from '../../../../constants'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class EndUsers extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        data: PropTypes.array,
        filter: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        personsEndUsersTableChange: PropTypes.func,
        sorted: PropTypes.array,
    }

    onTableChange = (changeData) => {
        const { personsEndUsersTableChange, module, block, id, level } = this.props

        personsEndUsersTableChange(module, block, id, level, changeData)
    }

    getColumnsDefinition = () => {
        const { filter, intl } = this.props

        return [
            {
                id: 'activity',
                accessor: 'inactive',
                Header: (val) => (
                    <div>
                        {val.Controls}
                        <InactivityIndicatorHeader />
                    </div>
                ),
                Cell: (value) => <InactiveIndicatorCell inactive={_.get(value, 'value', false)} />,
                width: 35,
                filterable: true,
                filter: {
                    type: 'VALUE',
                    value: _.map(_.get(filter, 'availableParameters.activity.availableValues', []), (x) => ({
                        value: _.get(x, 'value', null),
                        item: _.get(x, 'title', null),
                    })),
                },
            },
            {
                accessor: 'subject',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.subject` }),
                Cell: (value) => (
                    <div className={'persons-table-entity-cell'}>
                        {_.get(value, 'value.countryIso') !== 'CZ' && !_.isNil(_.get(value, 'value.countryIso')) && (
                            <Flag country={_.lowerCase(_.get(value, 'value.countryIso'))} />
                        )}
                        <Entity
                            entity={_.get(value, 'value', null)}
                            entId={_.get(value, 'value.id', null)}
                            inactive={_.get(value, 'value.inactive', false)}
                            type={_.get(value, 'value.type', null)}
                            value={_.get(value, 'value.name', null)}
                            rowInactive={_.get(value, 'original.inactive', false)}
                        />
                    </div>
                ),
            },
            {
                id: 'indicators',
                accessor: 'subject',
                sortable: true,
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.indicators` }),
                Cell: (value) => (
                    <CellStyleWrapper isNotActive={value?.original?.inactive}>
                        <Signals
                            id={_.get(value, 'value.id', null)}
                            caution={_.get(value, 'value.indicators.caution', 0)}
                            risk={_.get(value, 'value.indicators.risk', 0)}
                            notice={_.get(value, 'value.indicators.notice', 0)}
                        />
                    </CellStyleWrapper>
                ),
                width: 200,
            },
            {
                id: 'publicOfficial',
                accessor: 'publicOfficials',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.publicOfficial` }),
                Cell: ({ value, original }) => (
                    <CellStyleWrapper isNotActive={original?.inactive}>
                        {value ? intl.formatMessage({ id: 'global.yes' }) : intl.formatMessage({ id: 'global.no' })}
                    </CellStyleWrapper>
                ),
                width: 150,
                filterable: true,
                filter: {
                    type: 'VALUE',
                    value: _.map(_.get(filter, 'availableParameters.publicOfficial.availableValues', []), (x) => ({
                        value: _.get(x, 'value', null),
                        item: _.get(x, 'title', null),
                    })),
                },
            },
            {
                accessor: 'startDate',
                sortable: true,
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.startDate` }),
                Cell: (value) => (
                    <CellStyleWrapper isNotActive={value?.original?.inactive}>
                        <CustomDate
                            date={_.get(value, 'value.value', null)}
                            precision={_.get(value, 'value.precision', null)}
                        />
                    </CellStyleWrapper>
                ),
                width: 150,
            },
            {
                accessor: 'endDate',
                sortable: true,
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.endDate` }),
                Cell: (value) => (
                    <CellStyleWrapper isNotActive={value?.original?.inactive}>
                        <CustomDate
                            date={_.get(value, 'value.value', null)}
                            precision={_.get(value, 'value.precision', null)}
                        />
                    </CellStyleWrapper>
                ),
                width: 150,
            },
        ]
    }

    render() {
        const { id, data, filter, intl, isLoading, pagination, sorted } = this.props

        if (_.isEmpty(data) && _.isEmpty(filter?.activeFilters)) return null

        return (
            <div className={'persons-end-users-table-wrapper'}>
                <FilterTable
                    id={`persons-end-users-table-${id}`}
                    columnsDefinition={this.getColumnsDefinition()}
                    data={data ?? []}
                    onTableChange={this.onTableChange}
                    loading={isLoading}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                        filter: {
                            valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                            fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                        },
                    }}
                />
            </div>
        )
    }
}
